/* tslint:disable */
/* eslint-disable */
export enum WorkMontageplanBlockDiffOperationEnum {
  Create = 'create',
  Update = 'update',
  Delete = 'delete'
}
